'use client';

import type { FC } from 'react';

import { cn } from '@/lib/utils';

import {
    Select,
    SelectContent,
    SelectItem,
} from '@/components/molecules/Select';

import type { IntegrationSideContentTemplateType } from '../../IntegrationSideContentTemplate.types';

export interface SideSelectProps {
    listData: Array<Omit<IntegrationSideContentTemplateType, 'Icon' | 'title'>>;
}

const SideSelect: FC<SideSelectProps> = ({ listData }) => {
    const allListItems = listData.flatMap(item => item.list);

    return (
        <Select
            placeholder="Wybierz temat"
            className="md:!hidden"
        >
            <SelectContent>
                {allListItems.map(({ id, name, href }, index) => {
                    const newId = `${id}-${name}-${index}`;

                    return (
                        <SelectItem
                            key={newId}
                            id={newId}
                            value={id}
                            data-test-id={`section-integration-side-mobile-category-${id}`}
                        >
                            <a
                                href={href}
                                className={cn(
                                    'flex cursor-pointer items-center gap-x-4 py-2 text-typo-primary md:pr-4',
                                )}
                                data-test-id={`integration-side-select-content-${id}`}
                            >
                                <span className="text-sm font-extrabold">
                                    {name}
                                </span>
                            </a>
                        </SelectItem>
                    );
                })}
            </SelectContent>
        </Select>
    );
};

export default SideSelect;
